// hooks/useFundsMenu.js

import { useQuery } from '@tanstack/react-query';
import api, { fundApi } from 'api';
import { sectorFundsMenu } from 'utils/sectorFormatter';


export const useFundsMenu = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['fundsData'],
        queryFn: () => fundApi.allFunds().then((r) => r.data)
    });

    const fundsMenu = data?.data ? data.data : [];

    return {
        fundsMenu,
        isLoading
    };
};

export const useArchitectureMenu = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['architectureMenu'],
        queryFn: async () => {
            const res = await api.get('/architecture-menu');
            return res.data;
        }
    });
    const architectMenu = Array.isArray(data) ? sectorFundsMenu(data, 'architecture') : [];
    return { architectMenu, isLoading };
};